import React from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Grid, Dropdown, Button, Pagination, Input } from 'semantic-ui-react';
import View from './view';
import ReadCookie from '../../functions/readcookies';
import Permission from '../../functions/permission';
import Checkbox from '@material-ui/core/Checkbox';
import Brand from '../dropdown/brand';
import Branch from '../dropdown/branch';

class Analytics extends React.Component {

  state = {
    spareanalytics: [], pageNumber: 0, totalPages: 50,
    boundaryRange: 1, serialNumber: 0, type: 0,
    siblingRange: 1, search: '', showEllipsis: true,
    showFirstAndLastNav: true, checkbox: false,
    showPreviousAndNextNav: true, orderElement: 'partno',
    fromDate: this.getFormatedDate(new Date(), 7),
    toDate: this.getFormatedDate(new Date()),
    sortingOrder: 'DESC', menuPermission: []
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    return x;
  }

  type = (f, { value }) => {
    let fromDate = this.getFormatedDate(new Date(), value);
    this.setState({ type: value, fromDate })
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('analytics', this.props.menus);
    this.setState({ menuPermission })
  }

  checkBranch() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
      }
      return branchId;
    }
  }

  handlePaginationChange = (e, { activePage }) => {
    this.getStockDetails(activePage, this.state.fromDate, this.state.toDate, this.state.orderElement, this.state.sortingOrder);
  }

  handleChangeCheckbox = name => event => {
    this.setState({ [name]: event.target.checked })
  };

  getStockDetails(page, orderElement, sortingOrder) {
    let context = this;
    let error = 0;
    if (!this.state.fromDate) { error = 'Enter From date!!!'; }
    if (!this.state.toDate) { error = 'Enter To date!!!'; }
    if (!this.state.branch) { error = 'Select Branch!!!'; }
    if (!this.state.brand) { error = 'Select Branch!!!'; }
    if (error != 0) { alert(error); return; }
    context.setState({ load: true, message: 'Getting Spares' })
    $.ajax({
      type: 'POST',
      data: { 'fromDate': context.state.fromDate, 'toDate': context.state.toDate,
              'branch': context.state.branch, 'brand': context.state.brand,
              'search': context.state.search, 'orderElement': orderElement,
              'sortingOrder': sortingOrder, 'page': page },
      url: Server() + 'analytics/spareanalytics.php',
      success: function(data) {
        let totalPages = 0;
        try {
          data = JSON.parse(data);
          data.map((c) => { totalPages = c.totalpages; })
          context.setState({ spareanalytics: data, load: false, totalPages })
        } catch (e) {
          alert('Error!!!')
          context.setState({  load: false })
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value }); }

  updateData(data, sort) { this.setState({ spareanalytics: data, sort: sort }) }

  export() {
    if (!this.state.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!!');
      return;
    }
    let error = 0;
    if (!this.state.fromDate) { error = 'Select From Date'; }
    if (!this.state.toDate) { error = 'Select To Date'; }
    if (!this.state.brand) { error = 'Select Brand'; }
    if (!this.state.branch) { error = 'Select Branch'; }
    if (error != 0) { alert(error); return; }
    window.location = Server() + 'analytics/export.php?fromdate='+this.state.fromDate+
      '&todate='+this.state.toDate+'&search='+this.state.search+'&brand='+this.state.brand+
      '&branch='+this.state.branch;
  }

  brand(brand, allBrandArray) { this.setState({ brand, allBrandArray }) }

  branch(branch, allBranchArray) { this.setState({ branch, allBranchArray }) }

  onChange = (type) => (e, {value}) => { this.setState({ [type]: value }) }

  getStockDetails1(orderElement, sortingOrder) {
    if (sortingOrder == 'DESC') {
      this.setState({ orderElement: orderElement, sortingOrder: 'ASC' })
      this.getStockDetails(1, orderElement, 'ASC')
    }
    else {
      this.setState({ orderElement: orderElement, sortingOrder: 'DESC' })
      this.getStockDetails(1, orderElement, 'DESC')
    }
  }

  render() {
    let menuOption = [
      { key: 'Today', text: 'Today', value: 0 },
      { key: 'Yesterday', text: 'Yesterday', value: 1 },
      { key: 'Last 7 Days', text: 'Last 7 Days', value: 7 },
      { key: 'Last 1 Month', text: 'Last 1 Month', value: 30 },
      { key: 'Last 3 Month', text: 'Last 3 Month', value: 92 },
      { key: 'Last 6 Month', text: 'Last 6 Month', value: 182 },
      { key: 'Last 1 Year', text: 'Last 1 Year', value: 365 }
    ];
    return (
      <div>
        <Title title='Analytics' openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view  ?
          (
            <div style={{padding: '0.5%'}}>
              <div style={{display: 'flex'}}>
                <div style={{marginLeft: 5}}>
                  From Date<br/>
                  <input  onChange={this.handleChange('fromDate')} type="date"
                    value={this.state.fromDate} style={{ height: 35 }}/>
                </div>
                <div style={{marginLeft: 5}}>
                  To Date<br/>
                  <input  onChange={this.handleChange('toDate')} type="date"
                    value={this.state.toDate} style={{ height: 35 }} />
                </div>
                <div style={{marginLeft: 5, width: '20%'}}>
                  <br/>
                  <Dropdown onChange={this.type} selection
                    options={menuOption} value={this.state.type} />
                </div>
                <div style={{marginLeft: 5}}>
                  <br/>
                  <Brand update={this.brand.bind(this)} type='all' />
                </div>
                <div style={{marginLeft: 5}}>
                  <br/>
                  <Branch update={this.branch.bind(this)} type='all' />
                </div>
              </div>
              <div style={{display: 'flex'}}>
                <div style={{marginLeft: 5}}>
                  <Input placeholder='Search...' onChange={this.onChange('search')}
                    value={this.state.onChange}/>
                </div>
                <div style={{marginLeft: 5}}>
                  <Button onClick={this.getStockDetails.bind(this, 1, this.state.orderElement, this.state.sortingOrder)}>Submit</Button>
                </div>
                <div style={{marginLeft: 5}}>
                  <Button primary style={{display: this.state.analyticsexport}} onClick={this.export.bind(this)}>Export</Button>
                </div>
                <div style={{display: 'flex', marginLeft: 5}}>
                  <div style={{marginLeft: 2, display: 'flex', marginTop: 'auto', marginBottom: 'auto'}}>
                    <b>Movements:</b>
                  </div>
                  <div style={{marginLeft: 5, display: 'flex', marginTop: 'auto', marginBottom: 'auto'}}>
                    <div style={{width: 20, height: 20, background: '#CFFEC9', borderColor: 'black', borderWidth: 1, borderStyle: 'solid'}}></div>
                    <div style={{marginLeft: 2}}>Very Fast,</div>
                  </div>
                  <div style={{marginLeft: 5, display: 'flex', marginTop: 'auto', marginBottom: 'auto'}}>
                    <div style={{width: 20, height: 20, background: 'white', borderColor: 'black', borderWidth: 1, borderStyle: 'solid'}}></div>
                    <div style={{marginLeft: 2}}>Fast,</div>
                  </div>
                  <div style={{marginLeft: 5, display: 'flex', marginTop: 'auto', marginBottom: 'auto'}}>
                    <div style={{width: 20, height: 20, background: '#FEF4C9', borderColor: 'black', borderWidth: 1, borderStyle: 'solid'}}></div>
                    <div style={{marginLeft: 2}}>Avarage,</div>
                  </div>
                  <div style={{marginLeft: 5, display: 'flex', marginTop: 'auto', marginBottom: 'auto'}}>
                    <div style={{width: 20, height: 20, background: '#FFDAD2', borderColor: 'black', borderWidth: 1, borderStyle: 'solid'}}></div>
                    <div style={{marginLeft: 2}}>Slow</div>
                  </div>
                </div>
              </div>
              <div id='scrolls'>
                <View sort={this.state.sort} updateData={this.updateData.bind(this)}
                  getStockDetails1={this.getStockDetails1.bind(this)} serialNumber={this.state.serialNumber}
                  orderElement={this.state.orderElement} sortingOrder={this.state.sortingOrder}
                  spareanalytics={this.state.spareanalytics} />
              </div>
              <div align="right">
                <Pagination activePage={this.state.pageNumber} boundaryRange={this.state.boundaryRange}
                  onPageChange={this.handlePaginationChange} siblingRange={this.state.siblingRange}
                  totalPages={this.state.totalPages} ellipsisItem={this.state.showEllipsis ? undefined : null}
                  prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                  nextItem={this.state.showPreviousAndNextNav ? undefined : null} />
              </div>
              <Loading load={this.state.load} message={this.state.message} />
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Analytics;
